import { render, staticRenderFns } from "./TableEmptySlot.vue?vue&type=template&id=2295cbb2&scoped=true"
import script from "./TableEmptySlot.vue?vue&type=script&lang=ts"
export * from "./TableEmptySlot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295cbb2",
  null
  
)

export default component.exports